import React from "react";
import { Modal, Select } from "../../../components";
import {
  getSystemLabelTranslations,
  saveSystemLabelTranslations,
} from "./apiCalls";
import {
  ENGLISH_LANGUAGE_ID,
  addLanguage,
  updateMessage,
  removeLanguage,
} from "./translationList";

// Edits one system label's text in every language. Clearing or removing a language deletes its
// translation; the label then falls back to how that language handles missing texts.
class SystemLabelTranslations extends React.Component {
  state = {
    translations: [],
    removedLanguageIds: [],
    isLoading: true,
  };

  componentDidMount() {
    getSystemLabelTranslations(this.props.systemLabel.SystemLabelId).then(
      (res) => {
        if (res?.success) {
          this.setState({
            translations: res.items.Translations || [],
            isLoading: false,
          });
        } else {
          this.props.notify(res?.message || "Unable to load translations", "error");
          this.props.onClose();
        }
      }
    );
  }

  languageName = (languageId) =>
    (this.props.languages.find((l) => l.value === languageId) || {}).label ||
    languageId;

  updateMessage = (languageId, message) =>
    this.setState((st) => ({
      translations: updateMessage(st.translations, languageId, message),
    }));

  addLanguage = (option) => {
    if (!option) return;
    this.setState((st) => ({
      translations: addLanguage(st.translations, option.value),
      removedLanguageIds: st.removedLanguageIds.filter((id) => id !== option.value),
    }));
  };

  removeLanguage = (languageId) =>
    this.setState((st) => ({
      translations: removeLanguage(st.translations, languageId),
      removedLanguageIds: [...st.removedLanguageIds, languageId],
    }));

  handleSave = (e) => {
    e.preventDefault();
    const { translations, removedLanguageIds } = this.state;
    const english = translations.find((t) => t.LanguageId === ENGLISH_LANGUAGE_ID);
    if (english && !(english.Message || "").trim()) {
      this.props.notify("English text is required", "error");
      return;
    }
    // Removed languages are sent with an empty text, which deletes them on the server.
    const payload = {
      SystemLabelId: this.props.systemLabel.SystemLabelId,
      Translations: [
        ...translations.map((t) => ({ LanguageId: t.LanguageId, Message: t.Message })),
        ...removedLanguageIds.map((id) => ({ LanguageId: id, Message: "" })),
      ],
    };
    this.props.toggleLoading(true);
    saveSystemLabelTranslations(payload).then((res) => {
      this.props.toggleLoading(false);
      if (res?.success) {
        this.props.notify(res.message, "success");
        this.props.onSaved(res.items?.Translations || []);
      } else {
        this.props.notify(res?.message || "Unable to save translations", "error");
      }
    });
  };

  render() {
    const { systemLabel, languages, onClose, labels } = this.props;
    const { translations, isLoading } = this.state;
    const translatedIds = translations.map((t) => t.LanguageId);
    const sorted = [...translations].sort((a, b) =>
      a.LanguageId === ENGLISH_LANGUAGE_ID
        ? -1
        : b.LanguageId === ENGLISH_LANGUAGE_ID
        ? 1
        : String(this.languageName(a.LanguageId)).localeCompare(
            String(this.languageName(b.LanguageId))
          )
    );

    return (
      <Modal
        show={true}
        onButtonClose={onClose}
        title={`${labels.ADMIN_SYSTEM_LABEL_TRANSLATIONS || "Translations"}: ${
          systemLabel.Identifier
        }`}
        className="system-label-translations"
      >
        {isLoading ? (
          ""
        ) : (
          <form onSubmit={this.handleSave}>
            <table className="translations-table">
              <tbody>
                {sorted.map((t) => (
                  <tr key={t.LanguageId}>
                    <td className="translations-language">
                      {this.languageName(t.LanguageId)}
                    </td>
                    <td>
                      <textarea
                        rows={2}
                        value={t.Message || ""}
                        test-data-id={`translation-${t.LanguageId}`}
                        onChange={(e) =>
                          this.updateMessage(t.LanguageId, e.target.value)
                        }
                      />
                    </td>
                    <td className="translations-action">
                      {t.LanguageId !== ENGLISH_LANGUAGE_ID ? (
                        <button
                          type="button"
                          className="translations-remove"
                          onClick={() => this.removeLanguage(t.LanguageId)}
                        >
                          {labels.ADMIN_SYSTEM_LABEL_REMOVE_LANGUAGE || "Remove"}
                        </button>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Select
              placeholder={labels.ADMIN_SYSTEM_LABEL_ADD_LANGUAGE || "Add language"}
              value=""
              options={languages.filter((l) => !translatedIds.includes(l.value))}
              onChange={this.addLanguage}
            />
            <button type="submit" className="btn-login" test-data-id="save-translations-btn">
              {labels.ADMIN_SYSTEM_LABELS_SAVE}
            </button>
          </form>
        )}
      </Modal>
    );
  }
}

export default SystemLabelTranslations;
